import React from 'react'
import MultiComplete from 'components/Wizard2/fieldComponents/MultiComplete'
import { GET_REGULATED_WORD_LISTS } from 'requests'

const RegulatedWordsSelector = ({value, onChange, id}) => {
  const [regulatedWordLists, setRegulatedWordLists] = React.useState([])

  React.useEffect(() => {
    GET_REGULATED_WORD_LISTS(lists => {
      setRegulatedWordLists(lists.map(list => ({
        value: list.CATEGORY,
        label: list.DISPLAY_DESCR
      })))
    })
  }, [])

  return (
    <div> 
      <MultiComplete
        value={value}
        onChange={onChange}
        options={regulatedWordLists}
        width="70%"
        disabled={!regulatedWordLists.length}
      />
    </div>
  )
}

export default RegulatedWordsSelector


// WEBPACK FOOTER //
// ./src/components/Designer2/RegulatedWordsSelector.js